varying vec3 vPosition;

void main() {
  vPosition = csm_Position.xyz;
}